<template>
    <b-modal :ok-only="true" :centered="true" id="editColumnsModal" title="Edit Columns"
             body-class="scrollable" @ok="saveColumnSettings" @shown="updateFromFields">
        <draggable v-model="columnsList" element="ul" class="list-group">
            <li class="list-group-item" v-for="column in columnsList" v-if="column.title">
                <i class="fa fa-bars mr-2 align-middle"></i>
                <input class="mr-2 align-middle" v-model="column.selected" type="checkbox" :id="column.key">
                <label class="align-middle" :for="column.key">
                   {{ column.title }}
                </label>
            </li>
        </draggable>
    </b-modal>
</template>
<script>
    const draggable = require('vuedraggable');
    export default {
        name: 'EditColumns',
        components: {
            draggable
        },
        props: {
            fields: Array
        },
        data: function() {
            return {
                columnsList: []
            }
        },
        methods: {
            saveColumnSettings() {
                this.$emit('onEdit', this.columnsList);
            },
            updateFromFields () {
                this.columnsList = this.fields.slice();
            },
        },
    };
</script>
